import { Plus, Share, SquarePlus } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle
} from '@/components/ui/sheet'

const STEPS: { icon: ReactNode; text: ReactNode }[] = [
  {
    icon: <Share className='size-5' />,
    text: (
      <>
        Tap the <strong className='font-medium text-ink'>Share</strong> button
        in the browser toolbar.
      </>
    )
  },
  {
    icon: <SquarePlus className='size-5' />,
    text: (
      <>
        Scroll the list and tap{' '}
        <strong className='font-medium text-ink'>Add to Home Screen</strong>.
      </>
    )
  },
  {
    icon: <Plus className='size-5' />,
    text: (
      <>
        Tap <strong className='font-medium text-ink'>Add</strong>. TandemOne
        opens full screen from your Home Screen.
      </>
    )
  }
]

/* ios has no install prompt api, so a walkthrough of the share menu is the
 * only thing on offer. */
export function IosInstallSheet({
  open,
  onOpenChange
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side='bottom' className='rounded-t-2xl'>
        <SheetHeader>
          <SheetTitle className='text-base'>
            Add TandemOne to your Home Screen
          </SheetTitle>
          <SheetDescription className='text-sm'>
            Installs as a full-screen app with its own icon.
          </SheetDescription>
        </SheetHeader>
        <ol className='flex flex-col gap-3 px-4 sm:px-6'>
          {STEPS.map((step, index) => (
            <li key={index} className='flex items-start gap-3'>
              <span className='flex size-10 shrink-0 items-center justify-center rounded-lg bg-accent-light text-accent dark:text-accent-mid'>
                {step.icon}
              </span>
              <span className='pt-2.5 text-sm text-ink-soft'>{step.text}</span>
            </li>
          ))}
        </ol>
        <SheetFooter>
          <SheetClose asChild>
            <Button size='lg' className='w-full'>
              Got it
            </Button>
          </SheetClose>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  )
}
